module.exports = __webpack_public_path__ + "media/images/pages/primary-senior-leaders/download_brochure-857d4ef371dff5f08c38bd856bb6f094.svg";